/**
 * Generated from ZoraHurstonCutouts.fla
 */
export function ZoraHurstonCutouts(this: IZoraHurstonCutouts) {
	const cutouts = this.cutouts;
	if (!cutouts[0] && cutouts.elementFactory) {
		cutouts[0] = cutouts.elementFactory(0,undefined);
	}
	if (cutouts[0]) {
		ZoraHurstonCutouts_hurApple_cutout.call(cutouts[0] as IZoraHurstonCutouts_hurApple_cutout);
		cutouts[0].x = 943;
		cutouts[0].y = 689;
		if (cutouts[0].onLayout) cutouts[0].onLayout();
	}
	if (!cutouts[1] && cutouts.elementFactory) {
		cutouts[1] = cutouts.elementFactory(1,undefined);
	}
	if (cutouts[1]) {
		ZoraHurstonCutouts_hurBBigsmile_cutout.call(cutouts[1] as IZoraHurstonCutouts_hurBBigsmile_cutout);
		cutouts[1].x = 838.5;
		cutouts[1].y = 500;
		if (cutouts[1].onLayout) cutouts[1].onLayout();
	}
	if (!cutouts[2] && cutouts.elementFactory) {
		cutouts[2] = cutouts.elementFactory(2,undefined);
	}
	if (cutouts[2]) {
		ZoraHurstonCutouts_hurBBrave_cutout.call(cutouts[2] as IZoraHurstonCutouts_hurBBrave_cutout);
		cutouts[2].x = 858;
		cutouts[2].y = 505.5;
		if (cutouts[2].onLayout) cutouts[2].onLayout();
	}
	if (!cutouts[3] && cutouts.elementFactory) {
		cutouts[3] = cutouts.elementFactory(3,undefined);
	}
	if (cutouts[3]) {
		ZoraHurstonCutouts_hurBFpo_cutout.call(cutouts[3] as IZoraHurstonCutouts_hurBFpo_cutout);
		cutouts[3].x = 846.5;
		cutouts[3].y = 542.5;
		if (cutouts[3].onLayout) cutouts[3].onLayout();
	}
	if (!cutouts[4] && cutouts.elementFactory) {
		cutouts[4] = cutouts.elementFactory(4,undefined);
	}
	if (cutouts[4]) {
		ZoraHurstonCutouts_hurBHappy_cutout.call(cutouts[4] as IZoraHurstonCutouts_hurBHappy_cutout);
		cutouts[4].x = 865.5;
		cutouts[4].y = 506.5;
		if (cutouts[4].onLayout) cutouts[4].onLayout();
	}
	if (!cutouts[5] && cutouts.elementFactory) {
		cutouts[5] = cutouts.elementFactory(5,undefined);
	}
	if (cutouts[5]) {
		ZoraHurstonCutouts_hurBLaugh_cutout.call(cutouts[5] as IZoraHurstonCutouts_hurBLaugh_cutout);
		cutouts[5].x = 857;
		cutouts[5].y = 506.5;
		if (cutouts[5].onLayout) cutouts[5].onLayout();
	}
	if (!cutouts[6] && cutouts.elementFactory) {
		cutouts[6] = cutouts.elementFactory(6,undefined);
	}
	if (cutouts[6]) {
		ZoraHurstonCutouts_hurBNervous_cutout.call(cutouts[6] as IZoraHurstonCutouts_hurBNervous_cutout);
		cutouts[6].x = 858.5;
		cutouts[6].y = 518.5;
		if (cutouts[6].onLayout) cutouts[6].onLayout();
	}
	if (!cutouts[7] && cutouts.elementFactory) {
		cutouts[7] = cutouts.elementFactory(7,undefined);
	}
	if (cutouts[7]) {
		ZoraHurstonCutouts_hurBSad_cutout.call(cutouts[7] as IZoraHurstonCutouts_hurBSad_cutout);
		cutouts[7].x = 861;
		cutouts[7].y = 514.5;
		if (cutouts[7].onLayout) cutouts[7].onLayout();
	}
	if (!cutouts[8] && cutouts.elementFactory) {
		cutouts[8] = cutouts.elementFactory(8,undefined);
	}
	if (cutouts[8]) {
		ZoraHurstonCutouts_hurBShare_cutout.call(cutouts[8] as IZoraHurstonCutouts_hurBShare_cutout);
		cutouts[8].x = 858;
		cutouts[8].y = 504;
		if (cutouts[8].onLayout) cutouts[8].onLayout();
	}
	if (!cutouts[9] && cutouts.elementFactory) {
		cutouts[9] = cutouts.elementFactory(9,undefined);
	}
	if (cutouts[9]) {
		ZoraHurstonCutouts_hurBSitdraw_cutout.call(cutouts[9] as IZoraHurstonCutouts_hurBSitdraw_cutout);
		cutouts[9].x = 876;
		cutouts[9].y = 543;
		if (cutouts[9].onLayout) cutouts[9].onLayout();
	}
	if (!cutouts[10] && cutouts.elementFactory) {
		cutouts[10] = cutouts.elementFactory(10,undefined);
	}
	if (cutouts[10]) {
		ZoraHurstonCutouts_hurBSitdsurprised_cutout.call(cutouts[10] as IZoraHurstonCutouts_hurBSitdsurprised_cutout);
		cutouts[10].x = 858;
		cutouts[10].y = 532;
		if (cutouts[10].onLayout) cutouts[10].onLayout();
	}
	if (!cutouts[11] && cutouts.elementFactory) {
		cutouts[11] = cutouts.elementFactory(11,undefined);
	}
	if (cutouts[11]) {
		ZoraHurstonCutouts_hurBSitting_cutout.call(cutouts[11] as IZoraHurstonCutouts_hurBSitting_cutout);
		cutouts[11].x = 879.5;
		cutouts[11].y = 540.5;
		if (cutouts[11].onLayout) cutouts[11].onLayout();
	}
	if (!cutouts[12] && cutouts.elementFactory) {
		cutouts[12] = cutouts.elementFactory(12,undefined);
	}
	if (cutouts[12]) {
		ZoraHurstonCutouts_hurBSnacking_cutout.call(cutouts[12] as IZoraHurstonCutouts_hurBSnacking_cutout);
		cutouts[12].x = 860.5;
		cutouts[12].y = 503;
		if (cutouts[12].onLayout) cutouts[12].onLayout();
	}
	if (!cutouts[13] && cutouts.elementFactory) {
		cutouts[13] = cutouts.elementFactory(13,undefined);
	}
	if (cutouts[13]) {
		ZoraHurstonCutouts_hurChest_cutout.call(cutouts[13] as IZoraHurstonCutouts_hurChest_cutout);
		cutouts[13].x = 745.5;
		cutouts[13].y = 564;
		if (cutouts[13].onLayout) cutouts[13].onLayout();
	}
	if (!cutouts[14] && cutouts.elementFactory) {
		cutouts[14] = cutouts.elementFactory(14,undefined);
	}
	if (cutouts[14]) {
		ZoraHurstonCutouts_hurClassroomChair_cutout.call(cutouts[14] as IZoraHurstonCutouts_hurClassroomChair_cutout);
		cutouts[14].x = 895;
		cutouts[14].y = 645.5;
		if (cutouts[14].onLayout) cutouts[14].onLayout();
	}
	if (!cutouts[15] && cutouts.elementFactory) {
		cutouts[15] = cutouts.elementFactory(15,undefined);
	}
	if (cutouts[15]) {
		ZoraHurstonCutouts_hurClassroomChalkboard_cutout.call(cutouts[15] as IZoraHurstonCutouts_hurClassroomChalkboard_cutout);
		cutouts[15].x = 514.5;
		cutouts[15].y = 528;
		if (cutouts[15].onLayout) cutouts[15].onLayout();
	}
	if (!cutouts[16] && cutouts.elementFactory) {
		cutouts[16] = cutouts.elementFactory(16,undefined);
	}
	if (cutouts[16]) {
		ZoraHurstonCutouts_hurClassroomDesk_cutout.call(cutouts[16] as IZoraHurstonCutouts_hurClassroomDesk_cutout);
		cutouts[16].x = 684;
		cutouts[16].y = 562.5;
		if (cutouts[16].onLayout) cutouts[16].onLayout();
	}
	if (!cutouts[17] && cutouts.elementFactory) {
		cutouts[17] = cutouts.elementFactory(17,undefined);
	}
	if (cutouts[17]) {
		ZoraHurstonCutouts_hurClassroomPlant_cutout.call(cutouts[17] as IZoraHurstonCutouts_hurClassroomPlant_cutout);
		cutouts[17].x = 877.5;
		cutouts[17].y = 576.5;
		if (cutouts[17].onLayout) cutouts[17].onLayout();
	}
	if (!cutouts[18] && cutouts.elementFactory) {
		cutouts[18] = cutouts.elementFactory(18,undefined);
	}
	if (cutouts[18]) {
		ZoraHurstonCutouts_hurDanceparty_cutout.call(cutouts[18] as IZoraHurstonCutouts_hurDanceparty_cutout);
		cutouts[18].x = 823.5;
		cutouts[18].y = 633;
		if (cutouts[18].onLayout) cutouts[18].onLayout();
	}
	if (!cutouts[19] && cutouts.elementFactory) {
		cutouts[19] = cutouts.elementFactory(19,undefined);
	}
	if (cutouts[19]) {
		ZoraHurstonCutouts_hurDancepartySpeakerleft_cutout.call(cutouts[19] as IZoraHurstonCutouts_hurDancepartySpeakerleft_cutout);
		cutouts[19].x = 962.5;
		cutouts[19].y = 710;
		if (cutouts[19].onLayout) cutouts[19].onLayout();
	}
	if (!cutouts[20] && cutouts.elementFactory) {
		cutouts[20] = cutouts.elementFactory(20,undefined);
	}
	if (cutouts[20]) {
		ZoraHurstonCutouts_hurDancepartySpeakerright_cutout.call(cutouts[20] as IZoraHurstonCutouts_hurDancepartySpeakerright_cutout);
		cutouts[20].x = 962;
		cutouts[20].y = 706.5;
		if (cutouts[20].onLayout) cutouts[20].onLayout();
	}
	if (!cutouts[21] && cutouts.elementFactory) {
		cutouts[21] = cutouts.elementFactory(21,undefined);
	}
	if (cutouts[21]) {
		ZoraHurstonCutouts_hurDinoBook_cutout.call(cutouts[21] as IZoraHurstonCutouts_hurDinoBook_cutout);
		cutouts[21].x = 891.5;
		cutouts[21].y = 709;
		if (cutouts[21].onLayout) cutouts[21].onLayout();
	}
	if (!cutouts[22] && cutouts.elementFactory) {
		cutouts[22] = cutouts.elementFactory(22,undefined);
	}
	if (cutouts[22]) {
		ZoraHurstonCutouts_hurDinosaur_cutout.call(cutouts[22] as IZoraHurstonCutouts_hurDinosaur_cutout);
		cutouts[22].x = 158;
		cutouts[22].y = 378.5;
		if (cutouts[22].onLayout) cutouts[22].onLayout();
	}
	if (!cutouts[23] && cutouts.elementFactory) {
		cutouts[23] = cutouts.elementFactory(23,undefined);
	}
	if (cutouts[23]) {
		ZoraHurstonCutouts_hurIcecream_cutout.call(cutouts[23] as IZoraHurstonCutouts_hurIcecream_cutout);
		cutouts[23].x = 768;
		cutouts[23].y = 441.5;
		if (cutouts[23].onLayout) cutouts[23].onLayout();
	}
	if (!cutouts[24] && cutouts.elementFactory) {
		cutouts[24] = cutouts.elementFactory(24,undefined);
	}
	if (cutouts[24]) {
		ZoraHurstonCutouts_hurJam_cutout.call(cutouts[24] as IZoraHurstonCutouts_hurJam_cutout);
		cutouts[24].x = 796;
		cutouts[24].y = 527.5;
		if (cutouts[24].onLayout) cutouts[24].onLayout();
	}
	if (!cutouts[25] && cutouts.elementFactory) {
		cutouts[25] = cutouts.elementFactory(25,undefined);
	}
	if (cutouts[25]) {
		ZoraHurstonCutouts_hurKidzone_cutout.call(cutouts[25] as IZoraHurstonCutouts_hurKidzone_cutout);
		cutouts[25].x = 362.5;
		cutouts[25].y = 468.5;
		if (cutouts[25].onLayout) cutouts[25].onLayout();
	}
	if (!cutouts[26] && cutouts.elementFactory) {
		cutouts[26] = cutouts.elementFactory(26,undefined);
	}
	if (cutouts[26]) {
		ZoraHurstonCutouts_hurMarshmallow_cutout.call(cutouts[26] as IZoraHurstonCutouts_hurMarshmallow_cutout);
		cutouts[26].x = 854.5;
		cutouts[26].y = 573;
		if (cutouts[26].onLayout) cutouts[26].onLayout();
	}
	if (!cutouts[27] && cutouts.elementFactory) {
		cutouts[27] = cutouts.elementFactory(27,undefined);
	}
	if (cutouts[27]) {
		ZoraHurstonCutouts_hurMeatloaf_cutout.call(cutouts[27] as IZoraHurstonCutouts_hurMeatloaf_cutout);
		cutouts[27].x = 912.5;
		cutouts[27].y = 667;
		if (cutouts[27].onLayout) cutouts[27].onLayout();
	}
	if (!cutouts[28] && cutouts.elementFactory) {
		cutouts[28] = cutouts.elementFactory(28,undefined);
	}
	if (cutouts[28]) {
		ZoraHurstonCutouts_hurMoose_cutout.call(cutouts[28] as IZoraHurstonCutouts_hurMoose_cutout);
		cutouts[28].x = 629.5;
		cutouts[28].y = 284;
		if (cutouts[28].onLayout) cutouts[28].onLayout();
	}
	if (!cutouts[29] && cutouts.elementFactory) {
		cutouts[29] = cutouts.elementFactory(29,undefined);
	}
	if (cutouts[29]) {
		ZoraHurstonCutouts_hurMummy_cutout.call(cutouts[29] as IZoraHurstonCutouts_hurMummy_cutout);
		cutouts[29].x = 904;
		cutouts[29].y = 319;
		if (cutouts[29].onLayout) cutouts[29].onLayout();
	}
	if (!cutouts[30] && cutouts.elementFactory) {
		cutouts[30] = cutouts.elementFactory(30,undefined);
	}
	if (cutouts[30]) {
		ZoraHurstonCutouts_hurNewstoryBook_cutout.call(cutouts[30] as IZoraHurstonCutouts_hurNewstoryBook_cutout);
		cutouts[30].x = 732.5;
		cutouts[30].y = 707;
		if (cutouts[30].onLayout) cutouts[30].onLayout();
	}
	if (!cutouts[31] && cutouts.elementFactory) {
		cutouts[31] = cutouts.elementFactory(31,undefined);
	}
	if (cutouts[31]) {
		ZoraHurstonCutouts_hurNewstoryCrayon_cutout.call(cutouts[31] as IZoraHurstonCutouts_hurNewstoryCrayon_cutout);
		cutouts[31].x = 990;
		cutouts[31].y = 696;
		if (cutouts[31].onLayout) cutouts[31].onLayout();
	}
	if (!cutouts[32] && cutouts.elementFactory) {
		cutouts[32] = cutouts.elementFactory(32,undefined);
	}
	if (cutouts[32]) {
		ZoraHurstonCutouts_hurOctopus_cutout.call(cutouts[32] as IZoraHurstonCutouts_hurOctopus_cutout);
		cutouts[32].x = 728.5;
		cutouts[32].y = 371.5;
		if (cutouts[32].onLayout) cutouts[32].onLayout();
	}
	if (!cutouts[33] && cutouts.elementFactory) {
		cutouts[33] = cutouts.elementFactory(33,undefined);
	}
	if (cutouts[33]) {
		ZoraHurstonCutouts_hurOrange_cutout.call(cutouts[33] as IZoraHurstonCutouts_hurOrange_cutout);
		cutouts[33].x = 940;
		cutouts[33].y = 691;
		if (cutouts[33].onLayout) cutouts[33].onLayout();
	}
	if (!cutouts[34] && cutouts.elementFactory) {
		cutouts[34] = cutouts.elementFactory(34,undefined);
	}
	if (cutouts[34]) {
		ZoraHurstonCutouts_hurPlaygroundFront_cutout.call(cutouts[34] as IZoraHurstonCutouts_hurPlaygroundFront_cutout);
		cutouts[34].x = 839;
		cutouts[34].y = 561.5;
		if (cutouts[34].onLayout) cutouts[34].onLayout();
	}
	if (!cutouts[35] && cutouts.elementFactory) {
		cutouts[35] = cutouts.elementFactory(35,undefined);
	}
	if (cutouts[35]) {
		ZoraHurstonCutouts_hurPlaygroundStructure_cutout.call(cutouts[35] as IZoraHurstonCutouts_hurPlaygroundStructure_cutout);
		cutouts[35].x = 661.5;
		cutouts[35].y = 346.5;
		if (cutouts[35].onLayout) cutouts[35].onLayout();
	}
	if (!cutouts[36] && cutouts.elementFactory) {
		cutouts[36] = cutouts.elementFactory(36,undefined);
	}
	if (cutouts[36]) {
		ZoraHurstonCutouts_hurPopcorn_cutout.call(cutouts[36] as IZoraHurstonCutouts_hurPopcorn_cutout);
		cutouts[36].x = 924;
		cutouts[36].y = 638;
		if (cutouts[36].onLayout) cutouts[36].onLayout();
	}
	if (!cutouts[37] && cutouts.elementFactory) {
		cutouts[37] = cutouts.elementFactory(37,undefined);
	}
	if (cutouts[37]) {
		ZoraHurstonCutouts_hurStoryAgentchaos_cutout.call(cutouts[37] as IZoraHurstonCutouts_hurStoryAgentchaos_cutout);
		cutouts[37].x = 912;
		cutouts[37].y = 635.5;
		if (cutouts[37].onLayout) cutouts[37].onLayout();
	}
	if (!cutouts[38] && cutouts.elementFactory) {
		cutouts[38] = cutouts.elementFactory(38,undefined);
	}
	if (cutouts[38]) {
		ZoraHurstonCutouts_hurStoryBikeman_cutout.call(cutouts[38] as IZoraHurstonCutouts_hurStoryBikeman_cutout);
		cutouts[38].x = 915;
		cutouts[38].y = 637;
		if (cutouts[38].onLayout) cutouts[38].onLayout();
	}
	if (!cutouts[39] && cutouts.elementFactory) {
		cutouts[39] = cutouts.elementFactory(39,undefined);
	}
	if (cutouts[39]) {
		ZoraHurstonCutouts_hurStoryCape_cutout.call(cutouts[39] as IZoraHurstonCutouts_hurStoryCape_cutout);
		cutouts[39].x = 912;
		cutouts[39].y = 635.5;
		if (cutouts[39].onLayout) cutouts[39].onLayout();
	}
	if (!cutouts[40] && cutouts.elementFactory) {
		cutouts[40] = cutouts.elementFactory(40,undefined);
	}
	if (cutouts[40]) {
		ZoraHurstonCutouts_blyPlayground4_cutout.call(cutouts[40] as IZoraHurstonCutouts_blyPlayground4_cutout);
		cutouts[40].x = 787.3;
		cutouts[40].y = 743.95;
		if (cutouts[40].onLayout) cutouts[40].onLayout();
	}
	if (!cutouts[41] && cutouts.elementFactory) {
		cutouts[41] = cutouts.elementFactory(41,undefined);
	}
	if (cutouts[41]) {
		ZoraHurstonCutouts_blyPlaygroundBg_cutout.call(cutouts[41] as IZoraHurstonCutouts_blyPlaygroundBg_cutout);
		cutouts[41].x = 171.7;
		cutouts[41].y = 269.65;
		if (cutouts[41].onLayout) cutouts[41].onLayout();
	}
	if (!cutouts[42] && cutouts.elementFactory) {
		cutouts[42] = cutouts.elementFactory(42,undefined);
	}
	if (cutouts[42]) {
		ZoraHurstonCutouts_hur_bAmazed_cutout.call(cutouts[42] as IZoraHurstonCutouts_hur_bAmazed_cutout);
		cutouts[42].x = 719;
		cutouts[42].y = 504;
		if (cutouts[42].onLayout) cutouts[42].onLayout();
	}
	if (!cutouts[43] && cutouts.elementFactory) {
		cutouts[43] = cutouts.elementFactory(43,undefined);
	}
	if (cutouts[43]) {
		ZoraHurstonCutouts_hurDinosaurexhibitPterodactyl_cutout.call(cutouts[43] as IZoraHurstonCutouts_hurDinosaurexhibitPterodactyl_cutout);
		cutouts[43].x = 719;
		cutouts[43].y = 504;
		if (cutouts[43].onLayout) cutouts[43].onLayout();
	}
	if (!cutouts[44] && cutouts.elementFactory) {
		cutouts[44] = cutouts.elementFactory(44,undefined);
	}
	if (cutouts[44]) {
		ZoraHurstonCutouts_hurThoughtBubble_cutout.call(cutouts[44] as IZoraHurstonCutouts_hurThoughtBubble_cutout);
		cutouts[44].x = 719;
		cutouts[44].y = 504;
		if (cutouts[44].onLayout) cutouts[44].onLayout();
	}
	return this;
}
function ZoraHurstonCutouts_hurApple_cutout(this: IZoraHurstonCutouts_hurApple_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [22.15,-9.20,49.75,-11.05,67.55,0.00,94.55,-11.65,127.65,-9.20,156.50,8.60,173.25,43.05,172.45,95.15,152.50,140.05,133.00,156.20,111.00,160.25,85.05,171.85,54.75,168.30,28.50,151.05,1.35,118.05,-13.45,80.40,-11.25,39.05,22.45,7.25];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurApple.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 162.00;
	sprite.height = 158.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol1(this: IZoraHurstonCutouts_Symbol1) {
	return this;
}
function ZoraHurstonCutouts_hurApple(this: IZoraHurstonCutouts_hurApple) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-apple.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBBigsmile_cutout(this: IZoraHurstonCutouts_hurBBigsmile_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [201.45,-12.80,216.50,3.00,290.90,8.40,294.85,33.55,319.50,62.15,338.25,115.90,343.20,150.40,343.70,167.65,360.95,177.05,367.85,204.65,362.45,234.95,345.65,256.90,331.20,260.95,315.75,262.90,301.30,278.60,375.25,278.10,378.20,309.65,383.65,340.25,368.35,358.95,345.20,361.95,326.45,360.45,315.10,354.55,259.85,356.50,270.20,422.10,268.20,451.70,271.20,474.35,290.90,484.70,297.80,498.05,296.35,522.20,284.50,536.00,259.85,542.90,228.75,542.40,201.65,538.00,174.75,546.80,137.60,550.55,110.45,546.35,87.80,534.25,81.40,513.30,85.35,493.10,99.15,483.25,116.90,480.30,85.85,466.95,50.80,443.30,52.80,413.20,99.15,413.70,110.00,406.30,113.95,392.50,110.50,352.55,58.70,352.05,34.05,356.00,2.95,352.05,-8.35,336.30,-12.30,312.15,3.45,292.90,3.95,273.65,9.40,263.30,36.00,261.85,36.50,254.40,21.20,233.70,15.80,203.10,24.20,179.00,35.50,168.10,39.00,128.25,53.30,84.85,79.90,48.85,84.85,14.30,160.80,3.95,172.05,-11.30];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBBigsmile.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 371.00;
	sprite.height = 536.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol2(this: IZoraHurstonCutouts_Symbol2) {
	return this;
}
function ZoraHurstonCutouts_hurBBigsmile(this: IZoraHurstonCutouts_hurBBigsmile) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-bigsmile.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBBrave_cutout(this: IZoraHurstonCutouts_hurBBrave_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [242.45,0.05,272.90,17.45,304.60,51.00,320.75,89.55,325.10,129.30,323.85,157.25,336.25,167.20,343.70,184.50,345.60,208.55,331.90,239.30,315.15,254.20,297.10,256.70,282.20,255.45,252.35,279.70,259.80,293.35,261.05,323.80,252.10,351.95,234.55,383.15,221.70,393.85,218.95,424.25,212.25,438.85,217.70,458.30,238.05,464.65,251.10,478.95,251.10,507.95,235.50,523.85,207.50,528.35,183.05,526.85,158.10,538.55,111.00,537.00,79.15,527.60,68.70,513.60,67.70,487.90,73.55,467.00,60.85,450.45,64.65,362.55,39.75,337.65,31.35,317.00,33.65,293.60,43.80,276.00,63.15,263.00,46.15,245.20,22.95,244.45,0.80,229.90,-12.45,201.90,-11.70,168.55,0.30,150.20,11.75,143.85,15.30,99.00,33.50,45.00,67.70,9.15,127.80,-11.95,178.45,-13.65];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBBrave.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 332.00;
	sprite.height = 525.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol3(this: IZoraHurstonCutouts_Symbol3) {
	return this;
}
function ZoraHurstonCutouts_hurBBrave(this: IZoraHurstonCutouts_hurBBrave) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-brave.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBFpo_cutout(this: IZoraHurstonCutouts_hurBFpo_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [233.00,-3.10,269.25,17.50,291.70,44.95,309.20,89.90,311.10,148.00,313.20,174.45,309.90,198.40,289.40,221.85,268.45,249.45,241.20,272.00,219.75,284.60,241.75,334.75,253.00,334.15,266.75,307.30,291.75,287.90,326.10,285.65,356.70,303.90,368.15,338.40,366.65,377.25,352.30,414.10,327.30,440.30,287.95,445.30,253.60,435.30,218.05,426.00,188.05,423.50,141.25,434.75,92.50,465.35,63.10,465.35,45.60,455.35,30.00,437.85,2.50,436.60,-11.85,412.85,-9.95,381.65,5.00,368.50,7.50,340.40,23.15,314.20,43.45,302.05,59.10,297.35,70.95,269.50,53.75,251.10,28.75,247.95,4.40,227.95,-3.70,198.00,3.80,158.65,3.80,105.00,16.90,60.65,48.15,23.80,88.45,1.25,138.05,-13.70,189.90,-13.75];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBFpo.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 355.00;
	sprite.height = 451.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol4(this: IZoraHurstonCutouts_Symbol4) {
	return this;
}
function ZoraHurstonCutouts_hurBFpo(this: IZoraHurstonCutouts_hurBFpo) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-fpo.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBHappy_cutout(this: IZoraHurstonCutouts_hurBHappy_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [245.95,1.60,271.85,17.30,302.50,62.85,314.20,104.45,315.85,152.35,329.70,169.80,330.80,198.25,322.20,221.45,302.45,235.65,285.65,238.40,264.30,265.10,237.25,285.95,286.75,295.40,297.60,311.50,298.15,334.95,284.40,362.15,267.50,378.00,237.30,383.90,238.05,413.20,230.95,436.00,239.65,455.65,262.40,463.50,273.00,476.45,272.60,505.50,257.70,520.85,227.90,526.65,201.90,524.30,169.30,536.15,128.85,537.35,95.85,527.90,80.15,513.00,82.50,476.85,71.50,458.80,73.85,377.10,66.05,360.20,67.00,333.55,77.00,314.25,80.95,283.60,60.10,266.65,25.55,268.25,0.00,256.10,-13.35,227.85,-13.35,195.60,1.60,170.50,0.00,117.90,17.30,64.45,41.65,31.45,86.40,2.40,142.70,-13.05,200.35,-12.55];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBHappy.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 317.00;
	sprite.height = 523.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol5(this: IZoraHurstonCutouts_Symbol5) {
	return this;
}
function ZoraHurstonCutouts_hurBHappy(this: IZoraHurstonCutouts_hurBHappy) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-happy.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBLaugh_cutout(this: IZoraHurstonCutouts_hurBLaugh_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [230.85,-3.15,271.35,20.25,302.35,62.65,316.90,112.00,318.15,148.05,337.10,155.00,346.00,172.60,349.15,196.65,346.00,217.55,334.00,235.25,333.20,265.60,324.50,277.60,319.60,307.40,298.70,319.90,285.90,348.45,262.05,365.60,275.75,444.60,274.50,464.85,263.75,471.15,278.30,481.90,280.20,506.60,273.85,524.30,251.10,536.95,217.60,538.20,175.85,526.80,139.80,535.05,105.00,530.65,83.50,519.90,77.15,502.15,79.70,482.55,89.20,466.75,88.55,454.75,95.50,381.35,80.35,357.95,80.95,331.40,87.30,311.80,96.80,298.50,63.30,276.35,35.45,279.50,7.65,267.50,-9.45,239.65,-15.15,209.30,-6.90,187.15,5.10,179.60,-1.25,132.85,10.15,73.40,34.80,30.40,80.35,2.55,129.00,-12.60,180.25,-13.90];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBLaugh.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 334.00;
	sprite.height = 523.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol6(this: IZoraHurstonCutouts_Symbol6) {
	return this;
}
function ZoraHurstonCutouts_hurBLaugh(this: IZoraHurstonCutouts_hurBLaugh) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-laugh.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBNervous_cutout(this: IZoraHurstonCutouts_hurBNervous_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [213.85,-8.85,251.25,3.80,286.80,31.10,306.45,60.90,321.05,107.85,321.70,152.30,335.00,160.50,344.50,177.00,343.80,211.65,329.90,239.15,307.10,252.50,281.70,253.10,251.25,279.15,255.70,317.20,264.60,332.40,266.35,363.30,255.70,381.90,236.70,393.95,230.95,406.00,237.95,442.20,256.35,456.15,262.50,476.20,257.70,494.95,232.25,511.35,196.70,513.70,172.25,508.80,158.50,502.50,123.10,510.05,90.75,507.55,66.60,496.75,58.30,479.00,61.45,453.60,86.60,437.10,92.05,407.90,85.70,390.75,92.05,352.05,77.45,333.05,74.90,305.75,79.35,282.30,52.05,256.90,29.85,256.90,8.30,247.40,-8.85,225.85,-13.90,189.65,-5.70,164.30,10.20,155.40,7.00,109.80,22.25,60.95,54.60,14.65,110.40,-9.50,169.40,-16.50];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBNervous.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 331.00;
	sprite.height = 499.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol7(this: IZoraHurstonCutouts_Symbol7) {
	return this;
}
function ZoraHurstonCutouts_hurBNervous(this: IZoraHurstonCutouts_hurBNervous) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-nervous.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBSad_cutout(this: IZoraHurstonCutouts_hurBSad_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [272.30,14.65,307.30,54.10,320.65,105.00,321.30,147.00,337.20,155.20,341.00,182.55,332.75,207.35,315.00,226.75,294.55,233.40,269.10,260.80,225.25,290.05,236.00,366.40,239.20,415.40,232.20,432.55,223.30,439.55,248.10,449.75,257.65,465.00,254.45,491.10,236.65,507.00,205.50,512.10,184.50,510.80,157.80,519.70,126.60,522.20,95.45,519.05,70.00,508.25,63.00,491.70,66.20,462.45,52.55,444.85,63.65,291.30,71.25,265.85,43.90,237.90,17.45,233.55,-3.80,219.45,-15.25,190.15,-10.15,154.55,8.90,136.75,17.20,78.30,36.30,40.10,70.65,10.85,125.35,-12.05,181.35,-16.50,230.10,-9.10];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBSad.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 326.00;
	sprite.height = 507.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol8(this: IZoraHurstonCutouts_Symbol8) {
	return this;
}
function ZoraHurstonCutouts_hurBSad(this: IZoraHurstonCutouts_hurBSad) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-sad.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBShare_cutout(this: IZoraHurstonCutouts_hurBShare_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [248.95,3.90,284.80,38.45,306.45,84.50,314.20,130.60,330.45,138.00,340.45,164.50,335.35,193.95,318.05,217.60,299.50,222.70,277.05,252.75,239.30,288.55,245.10,302.65,284.10,284.70,294.45,275.50,322.75,278.60,325.05,301.35,341.65,315.15,342.60,343.50,330.20,360.85,304.95,367.90,282.20,366.00,243.15,384.25,244.80,421.90,237.25,439.30,244.45,458.75,270.05,468.35,280.90,485.05,280.90,505.50,266.20,525.95,234.20,533.00,209.25,531.10,181.10,540.70,140.80,543.25,107.50,535.55,85.75,522.75,88.30,485.65,78.10,476.70,77.45,382.65,53.80,360.90,49.30,327.60,59.55,302.65,78.75,288.60,59.55,274.50,28.20,275.80,1.95,264.25,-12.75,234.85,-12.85,202.55,-1.25,179.80,-5.75,126.05,7.05,74.25,43.55,26.90,91.55,0.65,139.55,-12.80,189.45,-13.40];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBShare.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 332.00;
	sprite.height = 528.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol9(this: IZoraHurstonCutouts_Symbol9) {
	return this;
}
function ZoraHurstonCutouts_hurBShare(this: IZoraHurstonCutouts_hurBShare) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-share.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBSitdraw_cutout(this: IZoraHurstonCutouts_hurBSitdraw_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [229.50,0.55,268.75,34.60,286.80,79.45,292.95,111.95,291.45,134.65,298.70,153.70,298.15,180.00,290.45,196.50,279.60,207.85,267.20,212.50,242.45,240.85,287.35,241.40,303.35,249.65,305.90,274.40,288.90,291.95,280.10,312.05,260.50,337.35,237.30,343.50,222.85,359.50,224.40,390.45,243.50,398.20,253.80,413.70,253.30,434.85,240.90,449.80,219.75,456.50,193.45,456.50,170.25,464.25,140.35,465.30,110.40,454.45,92.85,446.20,90.30,436.40,60.90,433.30,50.05,419.35,50.05,404.95,64.00,275.95,70.70,257.90,39.20,228.00,14.00,224.45,-6.15,206.90,-13.90,179.55,-10.25,151.70,-0.45,139.85,1.55,96.00,17.55,51.10,51.05,13.95,95.45,-7.20,138.95,-14.80,184.65,-12.90];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBSitdraw.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 296.00;
	sprite.height = 450.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol10(this: IZoraHurstonCutouts_Symbol10) {
	return this;
}
function ZoraHurstonCutouts_hurBSitdraw(this: IZoraHurstonCutouts_hurBSitdraw) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-sitdraw.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBSitdsurprised_cutout(this: IZoraHurstonCutouts_hurBSitdsurprised_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [268.90,5.85,294.80,29.15,314.90,69.35,323.95,108.85,322.65,135.40,337.15,145.80,341.45,175.20,331.10,200.85,314.25,213.80,296.10,219.65,317.50,239.20,317.65,274.15,298.70,288.90,283.80,316.10,268.25,325.80,251.40,326.45,254.65,343.30,271.45,334.25,294.40,328.60,321.10,335.95,341.30,359.30,345.80,396.05,339.50,427.55,319.40,458.00,299.35,476.80,274.05,485.20,251.40,484.55,223.55,465.80,199.55,452.80,166.40,445.10,130.60,454.10,82.60,477.75,49.65,481.40,21.40,467.70,1.95,445.65,-14.90,403.55,-11.00,364.70,-3.60,351.05,11.05,336.85,7.15,311.55,13.60,294.45,42.80,285.00,68.75,265.80,94.00,254.55,73.20,237.75,45.35,234.50,20.75,220.25,10.40,187.85,13.60,161.30,29.15,143.15,31.10,97.20,48.60,45.35,84.25,13.60,138.00,-10.35,187.90,-15.55,233.25,-10.35];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBSitdsurprised.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 332.00;
	sprite.height = 472.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol11(this: IZoraHurstonCutouts_Symbol11) {
	return this;
}
function ZoraHurstonCutouts_hurBSitdsurprised(this: IZoraHurstonCutouts_hurBSitdsurprised) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-sitdsurprised.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBSitting_cutout(this: IZoraHurstonCutouts_hurBSitting_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [251.05,16.25,277.10,56.60,282.80,86.65,282.30,106.65,291.40,133.35,300.50,140.50,302.45,168.45,295.30,182.05,279.70,187.95,269.30,200.25,267.35,215.90,243.20,246.45,213.35,266.00,228.30,308.90,238.05,339.45,257.60,351.85,262.15,383.05,251.05,397.35,241.95,403.20,241.30,438.35,228.95,455.25,206.85,460.45,184.10,469.55,153.50,466.30,135.95,453.30,126.20,442.25,98.85,441.60,79.35,435.10,68.95,424.70,47.50,416.85,26.65,398.65,25.35,372.00,33.85,353.15,52.70,338.15,67.65,261.45,32.50,238.75,3.25,203.60,-13.00,150.95,-13.65,106.70,0.00,57.25,23.40,21.85,58.55,-1.25,112.60,-14.25,158.05,-16.25,186.25,-10.55,214.00,-5.85];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBSitting.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 289.00;
	sprite.height = 455.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol12(this: IZoraHurstonCutouts_Symbol12) {
	return this;
}
function ZoraHurstonCutouts_hurBSitting(this: IZoraHurstonCutouts_hurBSitting) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-sitting.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurBSnacking_cutout(this: IZoraHurstonCutouts_hurBSnacking_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [244.50,-0.80,279.70,21.30,307.50,62.15,318.45,107.00,320.55,142.30,338.55,154.60,342.65,183.20,334.45,210.20,314.05,226.55,297.65,231.45,317.30,235.55,333.65,252.70,336.90,281.35,327.10,297.70,315.65,304.25,292.80,327.90,264.15,339.35,233.10,342.60,234.70,416.20,224.10,441.55,231.50,461.15,256.85,471.00,268.25,492.25,265.00,515.15,247.00,529.05,219.20,534.75,192.20,533.95,162.80,544.60,126.00,544.60,94.90,538.05,72.85,524.95,75.30,482.45,66.30,471.00,63.00,446.45,36.60,444.60,18.85,414.55,19.10,391.85,31.10,372.85,49.10,364.70,61.35,329.55,77.70,304.20,83.40,282.95,56.45,260.85,23.70,259.20,-3.25,241.20,-14.70,204.40,-8.55,173.40,2.45,162.70,3.70,111.65,18.80,64.65,49.90,23.75,98.95,-2.40,147.20,-15.50,201.15,-13.90];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurBSnacking.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 327.00;
	sprite.height = 530.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol13(this: IZoraHurstonCutouts_Symbol13) {
	return this;
}
function ZoraHurstonCutouts_hurBSnacking(this: IZoraHurstonCutouts_hurBSnacking) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-snacking.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurChest_cutout(this: IZoraHurstonCutouts_hurChest_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [523.90,-10.25,549.55,-3.75,567.05,21.60,571.90,53.45,568.15,94.55,556.50,140.70,542.10,183.55,539.45,398.35,530.25,410.80,455.20,421.70,307.20,420.05,202.90,422.60,119.05,420.25,38.40,421.10,0.00,418.10,-13.35,402.65,-14.40,277.35,-14.40,145.85,-2.05,128.40,51.35,125.30,9.25,57.55,9.10,32.80,50.40,5.20,108.10,-13.80];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurChest.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 557.00;
	sprite.height = 408.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol14(this: IZoraHurstonCutouts_Symbol14) {
	return this;
}
function ZoraHurstonCutouts_hurChest(this: IZoraHurstonCutouts_hurChest) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-chest.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurClassroomChair_cutout(this: IZoraHurstonCutouts_hurClassroomChair_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [239.35,10.00,262.35,50.40,269.60,93.85,271.95,142.95,267.95,187.65,262.55,214.50,267.65,232.20,264.30,251.95,247.70,258.80,227.75,260.05,127.55,254.25,-3.30,235.20,-8.55,226.65,-9.35,204.25,0.45,197.35,64.60,187.50,62.15,148.25,72.05,87.80,92.75,32.35,128.40,-2.20,174.80,-14.05,208.70,-8.25];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurClassroomChair.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 258.00;
	sprite.height = 245.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol15(this: IZoraHurstonCutouts_Symbol15) {
	return this;
}
function ZoraHurstonCutouts_hurClassroomChair(this: IZoraHurstonCutouts_hurClassroomChair) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-classroom-chair.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurClassroomChalkboard_cutout(this: IZoraHurstonCutouts_hurClassroomChalkboard_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [29.25,-13.55,997.00,-13.60,1008.80,-1.00,1011.85,27.80,1011.60,446.35,1029.20,453.00,1028.80,484.00,1010.80,492.15,690.05,494.10,448.85,491.55,155.70,493.95,-3.20,491.10,-12.15,480.60,-10.00,453.85,3.40,448.00,3.35,10.90,9.40,-7.25];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurClassroomChalkboard.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1019.00;
	sprite.height = 480.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol16(this: IZoraHurstonCutouts_Symbol16) {
	return this;
}
function ZoraHurstonCutouts_hurClassroomChalkboard(this: IZoraHurstonCutouts_hurClassroomChalkboard) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-classroom-chalkboard.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurClassroomDesk_cutout(this: IZoraHurstonCutouts_hurClassroomDesk_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [611.70,-9.60,617.55,9.25,615.80,37.40,629.95,44.25,636.45,55.85,682.15,61.10,691.45,69.65,692.00,89.35,689.20,102.10,690.50,156.75,689.20,220.45,688.95,287.80,682.55,304.80,675.95,335.55,669.40,340.40,636.85,339.10,593.40,371.15,589.45,411.10,581.10,420.80,554.30,421.65,543.75,412.45,540.25,383.45,50.35,309.80,46.35,327.60,38.75,336.25,13.75,335.90,6.40,328.85,0.75,300.40,-8.75,288.75,-9.30,106.70,-14.80,88.55,-12.60,67.65,-4.90,59.40,26.45,51.15,27.00,28.10,33.05,21.50,136.10,16.55,160.20,26.45,206.45,29.25,234.45,27.05,259.85,33.35,379.60,38.55,541.60,49.95,546.85,31.40,544.95,9.10,550.10,-7.50];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurClassroomDesk.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 680.00;
	sprite.height = 411.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol17(this: IZoraHurstonCutouts_Symbol17) {
	return this;
}
function ZoraHurstonCutouts_hurClassroomDesk(this: IZoraHurstonCutouts_hurClassroomDesk) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-classroom-desk.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurClassroomPlant_cutout(this: IZoraHurstonCutouts_hurClassroomPlant_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [108.10,-6.75,135.50,2.80,156.60,-10.55,184.35,-10.00,184.95,18.90,211.60,28.90,212.70,37.20,227.15,56.10,234.90,94.40,233.80,113.30,269.35,120.50,280.35,129.85,286.55,149.40,301.00,163.25,303.75,193.25,276.00,192.15,261.00,182.70,241.80,182.15,238.80,238.25,211.55,249.70,209.15,287.65,198.80,303.75,184.80,375.55,166.50,390.50,125.85,397.70,89.40,395.35,64.20,383.65,54.45,372.05,46.10,302.65,37.75,278.20,39.10,248.00,53.90,236.55,75.00,231.55,72.20,219.90,39.00,215.20,13.50,215.85,-2.75,203.75,-8.85,178.20,-2.10,149.40,12.65,128.15,-2.20,99.95,-11.95,82.65,-11.00,52.20,6.65,36.65,25.00,33.35,37.75,23.35,59.40,23.35,65.20,0.70,81.10,-3.90];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurClassroomPlant.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 293.00;
	sprite.height = 383.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol18(this: IZoraHurstonCutouts_Symbol18) {
	return this;
}
function ZoraHurstonCutouts_hurClassroomPlant(this: IZoraHurstonCutouts_hurClassroomPlant) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-classroom-plant.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurDanceparty_cutout(this: IZoraHurstonCutouts_hurDanceparty_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [31.20,-13.35,113.40,-13.55,302.75,-11.90,375.45,-10.75,390.65,5.45,397.15,38.00,410.15,61.85,414.95,104.70,415.25,255.50,398.35,278.55,377.30,281.50,15.90,281.90,-6.50,274.55,-13.00,255.00,-10.85,54.25,-6.50,38.00,4.35,33.65,8.60,-4.25];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurDanceparty.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 401.00;
	sprite.height = 270.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol19(this: IZoraHurstonCutouts_Symbol19) {
	return this;
}
function ZoraHurstonCutouts_hurDanceparty(this: IZoraHurstonCutouts_hurDanceparty) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-danceparty.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurDancepartySpeakerleft_cutout(this: IZoraHurstonCutouts_hurDancepartySpeakerleft_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [99.30,-7.65,126.45,17.50,136.65,54.15,126.80,96.90,101.70,121.70,65.25,131.10,18.80,121.65,-4.90,93.75,-15.35,56.70,-4.20,16.15,26.60,-8.35,60.15,-13.95];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurDancepartySpeakerleft.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 123.00;
	sprite.height = 116.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol20(this: IZoraHurstonCutouts_Symbol20) {
	return this;
}
function ZoraHurstonCutouts_hurDancepartySpeakerleft(this: IZoraHurstonCutouts_hurDancepartySpeakerleft) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-danceparty-speakerleft.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurDancepartySpeakerright_cutout(this: IZoraHurstonCutouts_hurDancepartySpeakerright_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [90.15,-7.85,115.35,4.50,133.85,35.25,137.20,68.30,122.65,109.20,90.15,132.70,56.00,137.70,16.25,125.40,-8.35,96.85,-12.85,57.65,-5.00,24.10,17.95,-0.55,59.35,-12.85];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurDancepartySpeakerright.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 124.00;
	sprite.height = 123.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol21(this: IZoraHurstonCutouts_Symbol21) {
	return this;
}
function ZoraHurstonCutouts_hurDancepartySpeakerright(this: IZoraHurstonCutouts_hurDancepartySpeakerright) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-danceparty-speakerright.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurDinoBook_cutout(this: IZoraHurstonCutouts_hurDinoBook_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [164.10,0.70,235.00,20.50,265.50,33.80,275.50,42.55,275.35,73.20,262.05,84.00,244.15,85.65,176.40,127.35,153.45,131.55,126.85,124.25,8.65,71.05,-9.50,53.20,-8.80,24.05,37.30,11.25,109.20,-10.10,134.75,-12.65];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurDinoBook.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 265.00;
	sprite.height = 118.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol22(this: IZoraHurstonCutouts_Symbol22) {
	return this;
}
function ZoraHurstonCutouts_hurDinoBook(this: IZoraHurstonCutouts_hurDinoBook) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-dino-book.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurDinosaur_cutout(this: IZoraHurstonCutouts_hurDinosaur_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [1091.85,22.00,1128.20,59.45,1140.30,80.35,1193.10,74.85,1281.20,77.05,1316.40,89.15,1350.30,76.80,1374.75,80.35,1378.20,90.20,1395.70,95.25,1400.20,107.70,1424.45,111.60,1428.95,127.95,1452.60,161.25,1467.85,169.70,1473.45,185.45,1512.95,188.25,1565.40,212.50,1567.65,244.05,1575.55,264.90,1574.40,288.05,1565.95,293.10,1569.35,319.05,1572.15,348.95,1584.55,354.55,1586.25,379.35,1568.20,388.40,1574.95,440.25,1584.00,472.95,1591.30,516.90,1646.00,490.40,1642.60,471.25,1649.35,451.50,1664.60,434.05,1693.90,434.05,1716.45,438.55,1730.55,461.65,1730.00,490.40,1742.35,502.25,1740.70,533.20,1723.20,541.15,1720.40,726.00,1744.05,748.00,1744.05,775.05,1719.85,787.45,1688.25,793.10,1660.10,789.70,1634.15,777.30,1629.10,755.90,1633.00,735.05,1651.65,723.20,1651.05,552.40,1614.40,568.15,1613.85,586.20,1629.10,605.95,1644.85,630.75,1643.15,656.65,1620.05,679.20,1596.95,688.80,1443.05,715.85,1382.75,718.65,1375.40,732.80,1331.45,739.00,1263.80,740.10,1245.20,744.05,1231.65,744.05,1217.00,753.65,1216.45,775.60,1187.70,788.60,1155.00,792.55,1125.70,789.15,1103.70,773.35,1022.55,776.20,962.80,780.15,904.75,772.25,852.30,776.80,798.20,772.85,755.35,767.20,703.50,764.95,686.00,773.40,660.10,776.80,629.65,776.20,600.30,788.05,572.10,794.80,541.10,788.60,518.00,775.10,514.60,751.40,468.45,746.30,443.05,742.95,401.90,741.25,372.60,731.65,367.55,718.10,326.35,715.90,279.00,716.45,221.50,708.00,186.00,692.75,156.65,670.80,123.40,673.05,81.15,656.70,80.00,727.70,96.35,740.10,103.10,755.90,100.85,774.50,85.65,786.90,49.55,793.70,16.40,791.40,-10.10,774.50,-11.80,745.75,11.90,726.00,10.20,538.90,-5.05,533.25,-6.75,505.05,6.20,490.95,1.90,471.10,11.30,447.00,32.70,436.30,58.65,432.90,63.15,406.40,74.40,394.00,69.90,368.10,72.70,341.55,97.55,312.85,112.20,289.75,126.85,277.90,128.55,260.95,137.00,236.15,176.45,224.90,186.60,213.05,208.60,201.20,220.45,186.00,245.80,183.20,246.35,170.80,280.75,144.30,302.15,142.05,303.30,129.10,349.50,109.95,355.70,98.10,404.15,82.30,427.85,62.05,459.95,63.15,495.50,67.10,520.30,66.55,526.45,34.40,533.80,27.65,558.05,22.60,581.15,28.80,587.90,43.45,586.20,59.80,666.25,47.95,669.65,25.95,677.55,16.40,699.75,12.20,715.85,17.50,724.90,33.30,718.70,86.85,752.50,85.70,779.00,73.30,810.00,73.85,838.20,78.35,856.80,86.25,882.15,77.80,908.65,71.60,941.35,70.45,956.65,76.50,971.30,46.80,993.75,22.55,1022.05,7.35,1058.25,7.75];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurDinosaur.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1732.00;
	sprite.height = 779.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol23(this: IZoraHurstonCutouts_Symbol23) {
	return this;
}
function ZoraHurstonCutouts_hurDinosaur(this: IZoraHurstonCutouts_hurDinosaur) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-dinosaur.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurIcecream_cutout(this: IZoraHurstonCutouts_hurIcecream_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [287.00,-6.80,292.25,22.35,290.80,45.40,300.15,64.10,324.65,74.90,349.45,89.40,373.75,123.60,382.70,155.60,385.25,180.80,413.25,183.15,428.15,208.50,461.30,225.25,492.95,259.05,508.80,299.35,513.75,327.05,512.00,354.05,523.10,365.50,523.90,392.20,507.35,402.30,506.65,446.90,491.65,507.90,463.75,564.30,423.85,614.60,378.55,647.00,323.10,662.10,249.70,669.30,192.50,663.10,156.90,653.25,104.35,619.65,56.90,569.25,28.85,509.50,13.00,455.55,10.85,405.15,-12.25,393.90,-11.10,361.20,9.40,349.75,25.95,336.05,25.95,302.95,40.30,290.75,38.15,260.50,45.35,243.95,75.15,232.85,73.40,190.00,87.80,147.55,111.55,112.30,149.70,84.95,186.40,66.95,226.70,57.60,234.65,38.90,257.65,33.15,251.20,21.60,256.85,-8.10];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurIcecream.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 512.00;
	sprite.height = 653.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol24(this: IZoraHurstonCutouts_Symbol24) {
	return this;
}
function ZoraHurstonCutouts_hurIcecream(this: IZoraHurstonCutouts_hurIcecream) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-icecream.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurJam_cutout(this: IZoraHurstonCutouts_hurJam_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [263.95,-7.30,272.70,3.65,288.70,8.75,298.20,21.90,325.15,28.45,344.10,49.60,379.10,72.20,386.40,103.55,411.20,107.90,433.05,127.60,446.90,153.85,448.35,173.50,463.65,177.00,469.05,203.20,357.55,473.30,344.10,482.55,268.60,494.75,191.75,495.70,116.80,485.50,97.80,472.05,-12.30,204.25,-10.15,178.60,14.60,169.85,35.25,158.20,43.65,135.90,66.80,108.15,97.70,99.90,102.80,73.65,137.05,48.85,168.40,50.30,185.20,18.95,209.95,1.45,235.60,-10.65];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurJam.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 456.00;
	sprite.height = 481.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol25(this: IZoraHurstonCutouts_Symbol25) {
	return this;
}
function ZoraHurstonCutouts_hurJam(this: IZoraHurstonCutouts_hurJam) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-jam.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurKidzone_cutout(this: IZoraHurstonCutouts_hurKidzone_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [359.45,-13.55,402.25,-11.45,417.90,1.70,439.30,-5.15,460.15,-1.45,480.50,-12.50,541.00,-12.50,568.70,-0.45,590.60,-3.60,629.65,4.30,636.50,23.20,632.80,44.70,639.60,62.55,640.10,101.95,633.35,109.80,635.45,158.10,687.60,160.75,706.90,151.80,747.60,148.15,753.85,133.95,786.70,127.65,796.05,99.30,814.85,98.25,826.30,78.30,842.50,72.55,889.95,76.75,936.95,96.70,939.00,74.65,948.90,74.10,952.05,40.00,989.60,34.20,1024.55,39.45,1031.30,64.15,1040.70,71.00,1042.80,91.45,1036.00,114.55,1043.30,136.60,1042.25,160.25,1099.10,163.90,1199.25,173.85,1258.70,181.20,1303.55,196.45,1310.35,218.50,1303.05,250.50,1281.70,295.65,1260.85,305.10,1245.70,306.15,1220.65,343.45,1273.00,347.55,1315.00,357.90,1334.95,375.50,1334.90,403.80,1317.65,429.50,1287.95,484.65,1297.50,521.10,1326.65,535.80,1327.50,560.00,1283.80,580.75,1199.25,586.50,1158.55,578.65,1119.45,573.40,1088.20,556.05,1088.20,534.55,1105.35,490.95,1054.80,499.35,945.50,505.35,731.05,508.15,697.40,504.40,722.90,565.95,716.95,586.60,683.25,601.10,603.60,610.10,529.85,605.00,476.55,588.55,464.25,575.55,465.95,554.70,481.60,547.10,499.65,500.30,476.25,459.20,358.95,462.30,230.50,453.05,240.75,476.65,234.20,495.95,200.40,507.60,127.25,518.55,45.90,512.90,4.20,496.20,-3.45,481.20,3.20,466.40,26.95,457.60,40.90,421.25,11.40,363.85,-9.35,349.00,-14.60,320.60,-5.95,300.20,47.05,285.85,106.15,280.70,72.45,264.85,54.35,233.75,46.20,200.55,52.60,173.90,110.25,157.55,238.70,148.35,329.75,144.90,326.40,38.50,322.95,14.60,325.15,-2.40];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurKidzone.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1323.00;
	sprite.height = 599.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol43(this: IZoraHurstonCutouts_Symbol43) {
	return this;
}
function ZoraHurstonCutouts_hurKidzone(this: IZoraHurstonCutouts_hurKidzone) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-kidzone.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurMarshmallow_cutout(this: IZoraHurstonCutouts_hurMarshmallow_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [144.40,-16.30,268.10,-2.20,343.60,19.25,353.95,40.00,351.75,88.15,345.85,147.30,342.85,288.00,342.15,362.05,323.60,384.25,287.30,393.15,182.90,405.00,88.85,403.55,1.50,390.20,-13.35,370.95,-14.80,337.65,-10.35,268.00,-14.05,124.45,-5.90,34.10,6.70,14.10,59.25,-5.90];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurMarshmallow.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 339.00;
	sprite.height = 390.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol26(this: IZoraHurstonCutouts_Symbol26) {
	return this;
}
function ZoraHurstonCutouts_hurMarshmallow(this: IZoraHurstonCutouts_hurMarshmallow) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-marshmallow.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurMeatloaf_cutout(this: IZoraHurstonCutouts_hurMeatloaf_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [107.65,-5.15,149.95,-14.80,190.75,-7.65,200.20,19.50,200.75,47.45,221.20,54.95,224.70,78.05,221.95,92.25,233.05,109.15,236.80,135.10,226.40,166.85,144.95,197.35,55.35,215.10,31.10,212.65,12.65,188.55,11.90,167.75,17.85,153.65,4.45,144.10,2.25,116.55,9.65,100.20,-5.20,89.85,-11.85,57.15,-5.90,34.15,35.75,11.80,89.40,4.30];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurMeatloaf.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 223.00;
	sprite.height = 202.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol27(this: IZoraHurstonCutouts_Symbol27) {
	return this;
}
function ZoraHurstonCutouts_hurMeatloaf(this: IZoraHurstonCutouts_hurMeatloaf) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-meatloaf.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurMoose_cutout(this: IZoraHurstonCutouts_hurMoose_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [401.90,103.05,421.55,91.55,443.25,83.70,456.25,59.50,488.80,59.50,495.30,92.05,497.15,122.70,524.15,98.10,546.40,41.85,579.85,40.95,586.35,62.30,575.20,103.20,606.80,78.10,633.75,37.20,657.00,-6.45,685.95,-8.70,689.65,14.35,665.35,75.30,679.30,82.75,707.20,61.40,725.75,36.30,754.60,40.00,755.50,68.80,768.25,74.90,768.50,103.20,755.95,126.60,727.35,142.80,657.80,187.50,609.60,190.55,537.10,196.15,464.10,202.55,495.45,225.45,522.65,255.45,545.50,258.40,576.15,280.70,597.50,314.15,656.05,323.45,683.00,333.70,699.75,349.45,728.40,357.15,736.00,365.25,752.70,386.65,764.80,394.95,762.95,418.20,753.65,426.55,756.45,454.45,743.45,516.70,736.45,554.10,710.00,595.65,692.30,663.50,688.60,721.15,675.90,763.55,687.65,843.80,707.15,874.50,704.40,927.45,682.15,939.55,650.55,942.35,618.95,934.90,604.05,917.25,584.55,928.40,556.65,927.45,553.90,959.05,537.15,978.55,511.15,982.30,479.55,976.70,456.30,963.70,454.45,941.40,458.15,905.15,453.55,845.70,436.85,769.50,418.25,678.40,399.65,665.40,397.80,621.70,387.60,586.40,361.50,557.55,342.00,502.75,345.70,459.05,321.55,464.65,298.35,461.10,284.40,442.35,255.60,431.20,238.65,409.70,235.15,346.65,251.45,310.20,267.70,271.35,265.80,237.00,280.35,211.05,225.40,194.10,177.40,190.90,77.20,171.65,18.60,117.10,-11.10,56.70,-11.10,25.10,16.75,21.40,22.35,-8.35,48.50,-9.10,84.60,61.35,92.95,51.10,117.35,49.60,139.45,79.95,147.80,66.00,172.90,67.85,186.85,90.15,193.30,52.15,220.35,50.90,233.75,73.15,237.00,104.10,261.65,97.65,307.20,103.25,334.90,122.60,343.45,133.90,388.30,135.00];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurMoose.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 789.00;
	sprite.height = 968.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol28(this: IZoraHurstonCutouts_Symbol28) {
	return this;
}
function ZoraHurstonCutouts_hurMoose(this: IZoraHurstonCutouts_hurMoose) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-moose.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurMummy_cutout(this: IZoraHurstonCutouts_hurMummy_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [186.40,-7.95,208.10,4.60,218.85,19.00,232.35,65.60,248.90,148.35,247.05,170.40,237.25,179.00,218.85,177.75,202.30,177.15,237.85,194.90,249.50,207.80,255.05,226.15,253.20,261.10,243.75,326.80,226.85,389.20,239.20,421.15,247.05,450.50,248.50,467.30,242.50,499.40,223.75,578.10,206.60,643.60,213.05,687.50,214.30,722.40,211.50,755.75,205.00,779.65,201.45,799.85,202.45,817.50,205.60,832.55,224.40,863.60,226.95,883.70,222.20,898.05,206.60,905.05,172.30,910.80,148.55,910.80,118.00,910.05,77.25,912.65,46.65,911.40,15.35,910.80,7.40,894.25,9.25,877.10,26.40,870.35,39.90,867.90,85.25,837.85,73.00,684.00,65.00,663.80,65.60,622.15,54.60,578.00,48.45,532.65,49.05,492.20,52.10,447.45,58.25,392.90,47.80,391.65,38.60,380.60,34.35,357.95,33.10,328.50,36.15,277.05,9.85,256.25,-7.35,229.90,-13.45,194.35,-9.15,169.85,3.10,155.75,20.85,149.60,41.10,152.05,55.80,157.55,55.80,139.55,75.15,68.70,91.35,16.60,99.25,1.05,120.15,-10.40,139.75,-14.05,160.00,-14.10];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurMummy.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 240.00;
	sprite.height = 898.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol29(this: IZoraHurstonCutouts_Symbol29) {
	return this;
}
function ZoraHurstonCutouts_hurMummy(this: IZoraHurstonCutouts_hurMummy) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-mummy.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurNewstoryBook_cutout(this: IZoraHurstonCutouts_hurNewstoryBook_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [365.75,-0.75,419.60,-14.60,441.05,-14.30,570.70,11.85,587.95,22.35,595.75,37.00,588.55,51.95,433.20,86.45,333.95,116.65,319.15,133.90,277.20,134.55,261.85,119.75,139.20,81.55,-4.45,46.40,-7.55,24.20,9.10,3.25,150.30,-15.85,178.05,-12.80,244.60,3.25,299.15,23.70];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurNewstoryBook.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 583.00;
	sprite.height = 122.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol30(this: IZoraHurstonCutouts_Symbol30) {
	return this;
}
function ZoraHurstonCutouts_hurNewstoryBook(this: IZoraHurstonCutouts_hurNewstoryBook) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-newstory-book.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurNewstoryCrayon_cutout(this: IZoraHurstonCutouts_hurNewstoryCrayon_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [78.25,3.60,80.20,25.85,52.80,107.65,21.85,153.30,-6.75,155.70,-13.15,133.45,-10.30,92.55,7.55,31.80,27.40,-8.70,59.95,-11.05];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurNewstoryCrayon.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 68.00;
	sprite.height = 144.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol31(this: IZoraHurstonCutouts_Symbol31) {
	return this;
}
function ZoraHurstonCutouts_hurNewstoryCrayon(this: IZoraHurstonCutouts_hurNewstoryCrayon) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-newstory-crayon.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurOctopus_cutout(this: IZoraHurstonCutouts_hurOctopus_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [298.90,146.95,282.65,117.35,283.25,58.05,311.40,6.00,353.75,-11.20,411.80,-11.80,468.55,-1.20,529.10,33.75,577.75,88.65,603.95,149.80,606.45,210.95,578.65,272.50,513.65,330.40,429.25,371.85,363.10,406.15,340.30,419.40,284.50,472.80,245.20,531.20,229.65,585.80,233.25,648.50,248.00,712.50,267.70,774.25,271.45,797.95,261.45,807.95,16.25,807.35,1.90,791.75,1.90,764.30,8.15,743.70,2.55,680.05,-12.45,650.75,-11.80,610.80,-1.20,582.10,6.25,532.15,-1.85,504.70,12.50,457.30,41.20,441.70,63.05,403.00,69.30,376.20,94.25,351.10,126.70,343.75,176.60,313.20,194.45,296.35,213.90,288.25,244.60,285.75,292.00,269.50,304.70,254.10,329.45,246.20,353.15,245.20,383.75,232.70,390.95,216.55,410.00,203.40,429.25,200.95,441.25,183.35,445.45,136.65,439.20,119.80,428.00,111.70,422.35,89.25,409.05,78.30,391.80,79.15,378.40,71.10,360.25,77.65,341.50,96.40,335.00,124.20,327.25,144.10];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurOctopus.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 591.00;
	sprite.height = 793.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol32(this: IZoraHurstonCutouts_Symbol32) {
	return this;
}
function ZoraHurstonCutouts_hurOctopus(this: IZoraHurstonCutouts_hurOctopus) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-octopus.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurOrange_cutout(this: IZoraHurstonCutouts_hurOrange_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [153.05,10.10,173.20,45.35,182.60,88.20,171.35,134.80,134.15,163.75,93.20,170.05,34.00,148.00,-7.55,110.25,-15.75,64.25,0.65,23.95,30.25,-3.15,77.45,-14.45,119.65,-9.45];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurOrange.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 168.00;
	sprite.height = 154.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol33(this: IZoraHurstonCutouts_Symbol33) {
	return this;
}
function ZoraHurstonCutouts_hurOrange(this: IZoraHurstonCutouts_hurOrange) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-orange.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurPlaygroundFront_cutout(this: IZoraHurstonCutouts_hurPlaygroundFront_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [293.70,129.15,322.50,95.35,347.70,96.35,361.80,113.50,365.35,138.25,379.50,145.80,385.05,178.60,378.50,224.55,366.90,274.50,337.10,313.90,300.80,339.60,272.00,350.75,274.00,417.85,245.75,428.45,216.45,427.95,186.70,415.85,181.15,353.25,142.85,340.60,107.55,309.80,93.40,276.50,90.90,248.75,94.90,223.00,44.95,213.45,8.10,195.80,-10.05,175.10,-12.55,149.85,-8.55,132.20,7.60,126.15,33.85,128.15,23.75,95.40,25.25,64.65,39.35,31.30,68.15,4.55,110.05,-10.55,155.95,-13.60,197.35,-6.50,227.15,11.65,246.30,43.40,253.90,82.75,250.90,120.05,275.05,121.05];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurPlaygroundFront.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 370.00;
	sprite.height = 413.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol34(this: IZoraHurstonCutouts_Symbol34) {
	return this;
}
function ZoraHurstonCutouts_hurPlaygroundFront(this: IZoraHurstonCutouts_hurPlaygroundFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-playground-front.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurPlaygroundStructure_cutout(this: IZoraHurstonCutouts_hurPlaygroundStructure_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [730.45,807.90,727.30,837.75,688.10,841.80,645.75,838.70,641.15,810.40,653.95,808.25,653.95,692.50,546.45,693.15,544.55,820.25,557.75,823.95,554.90,853.15,512.90,856.30,472.95,851.90,469.80,827.55,483.85,821.50,484.45,693.15,423.75,693.75,422.50,799.40,435.15,805.10,431.50,831.10,388.35,833.55,346.55,827.90,345.30,798.15,365.50,792.45,364.90,693.15,261.15,692.55,257.35,847.50,207.40,846.20,200.45,834.80,163.75,832.95,159.35,810.80,159.20,659.30,52.15,654.60,52.15,807.65,61.40,810.15,59.95,837.95,27.25,841.15,-7.55,838.00,-9.70,811.50,0.70,810.15,-0.60,629.25,0.65,609.80,12.05,592.60,204.85,340.25,204.80,340.10,421.40,407.90,487.50,404.80,547.30,436.25,655.85,429.95,714.85,431.05,712.85,804.35];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [500.85,-10.85,516.05,2.10,521.70,20.45,519.85,37.50,730.45,308.75,731.70,334.05,715.25,346.05,714.80,454.95,659.90,456.30,657.35,430.20,658.35,351.05,547.95,364.65,546.55,461.05,488.95,418.05,488.85,418.05,487.95,369.20,423.25,377.00,421.95,408.75,419.85,420.20,214.35,370.05,199.15,319.55,200.40,292.95,445.80,38.80,443.95,20.40,449.00,-1.10,474.50,-14.40];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurPlaygroundStructure.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 725.00;
	sprite.height = 843.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol35(this: IZoraHurstonCutouts_Symbol35) {
	return this;
}
function ZoraHurstonCutouts_Symbol40(this: IZoraHurstonCutouts_Symbol40) {
	return this;
}
function ZoraHurstonCutouts_hurPlaygroundStructure(this: IZoraHurstonCutouts_hurPlaygroundStructure) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-playground-structure.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurPopcorn_cutout(this: IZoraHurstonCutouts_hurPopcorn_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [140.55,-8.00,156.60,18.50,184.75,28.95,192.75,44.20,207.20,56.25,213.95,218.50,203.10,238.10,111.55,270.70,68.95,272.20,22.90,246.90,-13.60,98.80,-4.75,69.10,23.35,48.20,30.55,26.55,57.05,22.50,64.30,4.05,86.75,-2.35,106.05,-13.60];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurPopcorn.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 200.00;
	sprite.height = 260.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol37(this: IZoraHurstonCutouts_Symbol37) {
	return this;
}
function ZoraHurstonCutouts_hurPopcorn(this: IZoraHurstonCutouts_hurPopcorn) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-popcorn.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurStoryAgentchaos_cutout(this: IZoraHurstonCutouts_hurStoryAgentchaos_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [50.85,-13.50,147.35,3.20,220.05,20.60,238.05,37.30,238.05,54.70,217.45,152.55,196.00,270.15,178.35,279.15,88.15,267.05,-2.55,244.55,-12.20,228.45,-10.30,195.65,-11.55,169.90,5.15,153.80,0.65,115.20,3.25,93.35,10.30,84.95,12.85,27.70,21.25,18.05,25.65,-8.00];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurStoryAgentchaos.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 224.00;
	sprite.height = 265.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol38(this: IZoraHurstonCutouts_Symbol38) {
	return this;
}
function ZoraHurstonCutouts_hurStoryAgentchaos(this: IZoraHurstonCutouts_hurStoryAgentchaos) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-story-agentchaos.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurStoryBikeman_cutout(this: IZoraHurstonCutouts_hurStoryBikeman_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [50.85,-13.50,147.35,3.20,204.10,14.95,229.40,31.35,229.75,53.85,188.75,268.10,166.30,274.40,86.60,266.00,-1.50,242.00,-12.20,228.45,-10.30,195.65,-11.55,169.90,5.15,153.80,0.65,115.20,3.25,93.35,10.30,84.95,12.85,27.70,21.25,18.05,25.65,-8.00];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurStoryBikeman.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 218.00;
	sprite.height = 262.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol39(this: IZoraHurstonCutouts_Symbol39) {
	return this;
}
function ZoraHurstonCutouts_hurStoryBikeman(this: IZoraHurstonCutouts_hurStoryBikeman) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-story-bikeman.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurStoryCape_cutout(this: IZoraHurstonCutouts_hurStoryCape_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [50.85,-13.50,147.35,3.20,220.05,20.60,238.05,37.30,238.05,54.70,217.45,152.55,196.00,270.15,178.35,279.15,88.15,267.05,-2.55,244.55,-12.20,228.45,-10.30,195.65,-11.55,169.90,5.15,153.80,0.65,115.20,3.25,93.35,10.30,84.95,12.85,27.70,21.25,18.05,25.65,-8.00];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurStoryCape.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 224.00;
	sprite.height = 265.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_hurStoryCape(this: IZoraHurstonCutouts_hurStoryCape) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-story-cape.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_blyPlayground4_cutout(this: IZoraHurstonCutouts_blyPlayground4_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [233.40,-16.05,433.75,-12.45,442.25,7.25,462.30,13.65,471.15,25.70,477.95,39.70,466.10,54.45,413.40,59.35,367.55,55.15,360.10,40.60,126.85,41.75,116.40,58.60,54.60,64.20,-0.75,54.60,-4.55,35.35,8.85,24.10,13.25,14.45,34.55,10.45,45.40,-12.90];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_blyPlayground4.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 470.00;
	sprite.height = 48.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol17_(this: IZoraHurstonCutouts_Symbol17_) {
	return this;
}
function ZoraHurstonCutouts_blyPlayground4(this: IZoraHurstonCutouts_blyPlayground4) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-playground-bench.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_blyPlaygroundBg_cutout(this: IZoraHurstonCutouts_blyPlaygroundBg_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [496.80,-14.60,507.50,2.50,550.70,5.65,567.25,56.20,600.50,60.95,612.55,127.55,648.20,147.95,650.20,174.85,724.15,177.65,745.75,233.25,816.55,223.55,863.25,255.85,868.35,284.05,933.20,269.90,975.55,312.55,983.95,349.25,1012.55,347.35,1079.50,415.90,1072.30,485.90,1041.70,499.25,1029.70,550.70,1041.10,570.45,1027.40,607.00,1013.10,611.95,1009.70,635.70,935.80,674.35,894.50,668.45,888.55,691.65,854.05,697.75,838.90,769.30,852.55,769.30,863.60,736.45,904.25,738.50,928.90,763.60,978.80,761.50,995.10,773.25,1007.35,757.20,1031.05,751.35,1069.20,698.40,1102.10,698.60,1155.80,751.15,1172.25,738.20,1233.95,736.15,1255.95,766.40,1343.80,779.60,1364.30,818.00,1393.05,810.05,1432.90,828.00,1485.95,803.95,1544.65,810.60,1572.45,850.45,1614.40,845.20,1660.10,866.45,1689.15,890.60,1712.00,912.70,1723.45,967.05,1688.30,1000.30,1541.90,1003.15,1348.95,998.35,1273.10,1003.15,1241.65,999.15,963.05,1000.75,901.75,1005.55,789.55,1011.90,735.60,1006.35,669.00,1010.30,608.70,1002.35,454.90,1001.55,302.05,999.95,155.00,1007.10,68.30,992.75,19.60,987.45,4.20,966.85,5.30,939.00,32.65,919.20,59.80,855.55,76.10,851.90,84.05,832.00,124.75,788.70,157.95,791.40,176.40,770.15,197.05,767.80,208.45,757.60,234.65,757.65,285.45,808.95,321.20,803.85,350.60,770.65,356.45,741.90,410.90,701.85,436.10,700.10,431.50,659.30,411.10,663.85,372.00,650.55,367.95,626.45,382.20,595.55,346.30,580.40,339.35,590.15,292.40,586.00,275.70,608.40,245.35,610.30,204.50,574.60,184.40,584.90,156.15,582.90,135.05,556.60,138.35,521.65,88.05,513.40,79.45,483.85,32.55,485.05,17.55,450.35,0.75,439.65,-8.75,398.55,-2.15,384.70,-15.85,360.70,-3.00,282.25,46.85,277.65,51.80,274.35,18.10,228.20,-7.70,214.45,-10.65,160.90,9.50,148.65,8.40,118.05,50.85,28.20,87.50,16.05,134.95,46.85,166.20,41.70,214.10,80.25,229.85,76.30,248.15,50.70,291.40,54.90,309.90,36.65,345.85,36.40,359.45,55.35,381.70,13.45,465.70,-14.60];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_blyPlaygroundBg.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1708.00;
	sprite.height = 998.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol46_(this: IZoraHurstonCutouts_Symbol46_) {
	return this;
}
function ZoraHurstonCutouts_blyPlaygroundBg(this: IZoraHurstonCutouts_blyPlaygroundBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-playground-bg.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hur_bAmazed_cutout(this: IZoraHurstonCutouts_hur_bAmazed_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [205.55,-13.75,257.65,4.95,300.95,51.15,316.65,105.25,316.65,140.65,335.35,151.45,337.30,188.85,320.60,219.35,292.10,230.15,270.45,277.35,280.30,317.65,274.40,348.15,246.85,362.90,250.80,416.00,243.90,445.50,251.75,464.20,278.30,473.05,288.15,495.65,283.25,518.30,255.70,533.05,211.45,535.00,175.05,544.80,131.80,541.85,93.45,528.10,94.45,485.80,85.60,468.10,85.60,322.60,94.45,288.15,54.70,257.35,17.45,254.80,-4.90,237.05,-14.75,200.65,-10.80,173.10,2.00,161.30,4.95,104.25,26.60,43.30,79.70,5.90,146.55,-16.70];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hur_bAmazed.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 323.00;
	sprite.height = 529.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol41(this: IZoraHurstonCutouts_Symbol41) {
	return this;
}
function ZoraHurstonCutouts_hur_bAmazed(this: IZoraHurstonCutouts_hur_bAmazed) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur_b-amazed.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurDinosaurexhibitPterodactyl_cutout(this: IZoraHurstonCutouts_hurDinosaurexhibitPterodactyl_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [56.55,-13.10,57.40,135.95,139.85,186.20,160.55,186.20,176.30,206.90,176.30,247.25,182.20,317.20,251.45,358.55,252.15,316.55,219.90,294.60,219.25,268.20,251.75,268.95,251.75,-9.10,283.05,-10.80,282.35,280.80,329.95,297.50,372.30,323.10,413.65,302.40,531.65,276.80,532.40,-8.85,563.35,-8.80,564.55,266.20,585.35,265.25,617.55,269.90,612.95,298.55,576.15,298.50,477.70,336.90,448.15,336.90,421.55,352.65,464.65,378.30,495.50,410.50,499.35,440.05,462.15,435.00,464.35,458.60,431.20,457.65,367.55,420.50,322.15,404.40,281.20,417.35,263.55,438.05,235.80,446.35,185.15,441.30,156.35,443.85,129.20,456.75,70.25,457.70,54.50,436.15,31.40,425.35,32.15,401.60,56.70,395.30,96.85,397.20,95.80,366.70,75.05,339.85,45.40,307.35,11.35,175.90,-5.95,143.10,-8.50,115.10,25.60,119.80,25.25,-12.05];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurDinosaurexhibitPterodactyl.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 614.00;
	sprite.height = 449.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol42(this: IZoraHurstonCutouts_Symbol42) {
	return this;
}
function ZoraHurstonCutouts_hurDinosaurexhibitPterodactyl(this: IZoraHurstonCutouts_hurDinosaurexhibitPterodactyl) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-dinosaurexhibit-pterodactyl.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonCutouts_hurThoughtBubble_cutout(this: IZoraHurstonCutouts_hurThoughtBubble_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [287.85,-2.35,314.90,20.70,349.90,23.85,382.50,39.00,404.75,70.00,436.55,83.50,470.75,116.90,488.25,162.25,487.45,217.90,467.55,257.65,454.05,275.15,463.60,291.85,477.95,300.90,480.35,326.60,466.40,346.95,433.90,343.15,405.55,329.25,394.20,305.20,366.75,310.25,335.55,306.20,299.00,330.05,244.90,334.00,211.50,352.25,153.80,348.60,120.05,322.85,77.95,321.25,29.45,295.80,-4.75,250.45,-14.25,190.85,-3.15,139.95,18.35,112.90,17.50,69.20,36.60,31.80,87.50,6.35,134.40,9.55,178.15,-7.95,225.90,-14.40];
	}
	const sprite = this.sprite;
	ZoraHurstonCutouts_hurThoughtBubble.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 475.00;
	sprite.height = 339.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function ZoraHurstonCutouts_Symbol44(this: IZoraHurstonCutouts_Symbol44) {
	return this;
}
function ZoraHurstonCutouts_hurThoughtBubble(this: IZoraHurstonCutouts_hurThoughtBubble) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-thought-bubble.png", 0.000, 0.000);
	return this;
}
interface IZoraHurstonCutoutsArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IZoraHurstonCutoutsContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IZoraHurstonCutoutsSprite extends IZoraHurstonCutoutsContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IZoraHurstonCutoutsText extends IZoraHurstonCutoutsContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IZoraHurstonCutoutsPolygon extends Array<number> {
}
interface IZoraHurstonCutouts {
	readonly cutouts: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_hurApple_cutout|IZoraHurstonCutouts_hurBBigsmile_cutout|IZoraHurstonCutouts_hurBBrave_cutout|IZoraHurstonCutouts_hurBFpo_cutout|IZoraHurstonCutouts_hurBHappy_cutout|IZoraHurstonCutouts_hurBLaugh_cutout|IZoraHurstonCutouts_hurBNervous_cutout|IZoraHurstonCutouts_hurBSad_cutout|IZoraHurstonCutouts_hurBShare_cutout|IZoraHurstonCutouts_hurBSitdraw_cutout|IZoraHurstonCutouts_hurBSitdsurprised_cutout|IZoraHurstonCutouts_hurBSitting_cutout|IZoraHurstonCutouts_hurBSnacking_cutout|IZoraHurstonCutouts_hurChest_cutout|IZoraHurstonCutouts_hurClassroomChair_cutout|IZoraHurstonCutouts_hurClassroomChalkboard_cutout|IZoraHurstonCutouts_hurClassroomDesk_cutout|IZoraHurstonCutouts_hurClassroomPlant_cutout|IZoraHurstonCutouts_hurDanceparty_cutout|IZoraHurstonCutouts_hurDancepartySpeakerleft_cutout|IZoraHurstonCutouts_hurDancepartySpeakerright_cutout|IZoraHurstonCutouts_hurDinoBook_cutout|IZoraHurstonCutouts_hurDinosaur_cutout|IZoraHurstonCutouts_hurIcecream_cutout|IZoraHurstonCutouts_hurJam_cutout|IZoraHurstonCutouts_hurKidzone_cutout|IZoraHurstonCutouts_hurMarshmallow_cutout|IZoraHurstonCutouts_hurMeatloaf_cutout|IZoraHurstonCutouts_hurMoose_cutout|IZoraHurstonCutouts_hurMummy_cutout|IZoraHurstonCutouts_hurNewstoryBook_cutout|IZoraHurstonCutouts_hurNewstoryCrayon_cutout|IZoraHurstonCutouts_hurOctopus_cutout|IZoraHurstonCutouts_hurOrange_cutout|IZoraHurstonCutouts_hurPlaygroundFront_cutout|IZoraHurstonCutouts_hurPlaygroundStructure_cutout|IZoraHurstonCutouts_hurPopcorn_cutout|IZoraHurstonCutouts_hurStoryAgentchaos_cutout|IZoraHurstonCutouts_hurStoryBikeman_cutout|IZoraHurstonCutouts_hurStoryCape_cutout|IZoraHurstonCutouts_blyPlayground4_cutout|IZoraHurstonCutouts_blyPlaygroundBg_cutout|IZoraHurstonCutouts_hur_bAmazed_cutout|IZoraHurstonCutouts_hurDinosaurexhibitPterodactyl_cutout|IZoraHurstonCutouts_hurThoughtBubble_cutout>;
}
interface IZoraHurstonCutouts_hurApple_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol1>;
	readonly sprite: IZoraHurstonCutouts_hurApple;
}
interface IZoraHurstonCutouts_Symbol1 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurApple extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBBigsmile_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol2>;
	readonly sprite: IZoraHurstonCutouts_hurBBigsmile;
}
interface IZoraHurstonCutouts_Symbol2 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBBigsmile extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBBrave_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol3>;
	readonly sprite: IZoraHurstonCutouts_hurBBrave;
}
interface IZoraHurstonCutouts_Symbol3 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBBrave extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBFpo_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol4>;
	readonly sprite: IZoraHurstonCutouts_hurBFpo;
}
interface IZoraHurstonCutouts_Symbol4 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBFpo extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBHappy_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol5>;
	readonly sprite: IZoraHurstonCutouts_hurBHappy;
}
interface IZoraHurstonCutouts_Symbol5 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBHappy extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBLaugh_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol6>;
	readonly sprite: IZoraHurstonCutouts_hurBLaugh;
}
interface IZoraHurstonCutouts_Symbol6 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBLaugh extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBNervous_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol7>;
	readonly sprite: IZoraHurstonCutouts_hurBNervous;
}
interface IZoraHurstonCutouts_Symbol7 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBNervous extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBSad_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol8>;
	readonly sprite: IZoraHurstonCutouts_hurBSad;
}
interface IZoraHurstonCutouts_Symbol8 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBSad extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBShare_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol9>;
	readonly sprite: IZoraHurstonCutouts_hurBShare;
}
interface IZoraHurstonCutouts_Symbol9 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBShare extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBSitdraw_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol10>;
	readonly sprite: IZoraHurstonCutouts_hurBSitdraw;
}
interface IZoraHurstonCutouts_Symbol10 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBSitdraw extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBSitdsurprised_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol11>;
	readonly sprite: IZoraHurstonCutouts_hurBSitdsurprised;
}
interface IZoraHurstonCutouts_Symbol11 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBSitdsurprised extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBSitting_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol12>;
	readonly sprite: IZoraHurstonCutouts_hurBSitting;
}
interface IZoraHurstonCutouts_Symbol12 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBSitting extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurBSnacking_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol13>;
	readonly sprite: IZoraHurstonCutouts_hurBSnacking;
}
interface IZoraHurstonCutouts_Symbol13 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurBSnacking extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurChest_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol14>;
	readonly sprite: IZoraHurstonCutouts_hurChest;
}
interface IZoraHurstonCutouts_Symbol14 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurChest extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurClassroomChair_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol15>;
	readonly sprite: IZoraHurstonCutouts_hurClassroomChair;
}
interface IZoraHurstonCutouts_Symbol15 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurClassroomChair extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurClassroomChalkboard_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol16>;
	readonly sprite: IZoraHurstonCutouts_hurClassroomChalkboard;
}
interface IZoraHurstonCutouts_Symbol16 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurClassroomChalkboard extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurClassroomDesk_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol17>;
	readonly sprite: IZoraHurstonCutouts_hurClassroomDesk;
}
interface IZoraHurstonCutouts_Symbol17 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurClassroomDesk extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurClassroomPlant_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol18>;
	readonly sprite: IZoraHurstonCutouts_hurClassroomPlant;
}
interface IZoraHurstonCutouts_Symbol18 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurClassroomPlant extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurDanceparty_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol19>;
	readonly sprite: IZoraHurstonCutouts_hurDanceparty;
}
interface IZoraHurstonCutouts_Symbol19 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurDanceparty extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurDancepartySpeakerleft_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol20>;
	readonly sprite: IZoraHurstonCutouts_hurDancepartySpeakerleft;
}
interface IZoraHurstonCutouts_Symbol20 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurDancepartySpeakerleft extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurDancepartySpeakerright_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol21>;
	readonly sprite: IZoraHurstonCutouts_hurDancepartySpeakerright;
}
interface IZoraHurstonCutouts_Symbol21 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurDancepartySpeakerright extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurDinoBook_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol22>;
	readonly sprite: IZoraHurstonCutouts_hurDinoBook;
}
interface IZoraHurstonCutouts_Symbol22 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurDinoBook extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurDinosaur_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol23>;
	readonly sprite: IZoraHurstonCutouts_hurDinosaur;
}
interface IZoraHurstonCutouts_Symbol23 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurDinosaur extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurIcecream_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol24>;
	readonly sprite: IZoraHurstonCutouts_hurIcecream;
}
interface IZoraHurstonCutouts_Symbol24 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurIcecream extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurJam_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol25>;
	readonly sprite: IZoraHurstonCutouts_hurJam;
}
interface IZoraHurstonCutouts_Symbol25 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurJam extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurKidzone_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol43>;
	readonly sprite: IZoraHurstonCutouts_hurKidzone;
}
interface IZoraHurstonCutouts_Symbol43 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurKidzone extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurMarshmallow_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol26>;
	readonly sprite: IZoraHurstonCutouts_hurMarshmallow;
}
interface IZoraHurstonCutouts_Symbol26 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurMarshmallow extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurMeatloaf_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol27>;
	readonly sprite: IZoraHurstonCutouts_hurMeatloaf;
}
interface IZoraHurstonCutouts_Symbol27 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurMeatloaf extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurMoose_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol28>;
	readonly sprite: IZoraHurstonCutouts_hurMoose;
}
interface IZoraHurstonCutouts_Symbol28 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurMoose extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurMummy_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol29>;
	readonly sprite: IZoraHurstonCutouts_hurMummy;
}
interface IZoraHurstonCutouts_Symbol29 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurMummy extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurNewstoryBook_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol30>;
	readonly sprite: IZoraHurstonCutouts_hurNewstoryBook;
}
interface IZoraHurstonCutouts_Symbol30 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurNewstoryBook extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurNewstoryCrayon_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol31>;
	readonly sprite: IZoraHurstonCutouts_hurNewstoryCrayon;
}
interface IZoraHurstonCutouts_Symbol31 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurNewstoryCrayon extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurOctopus_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol32>;
	readonly sprite: IZoraHurstonCutouts_hurOctopus;
}
interface IZoraHurstonCutouts_Symbol32 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurOctopus extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurOrange_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol33>;
	readonly sprite: IZoraHurstonCutouts_hurOrange;
}
interface IZoraHurstonCutouts_Symbol33 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurOrange extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurPlaygroundFront_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol34>;
	readonly sprite: IZoraHurstonCutouts_hurPlaygroundFront;
}
interface IZoraHurstonCutouts_Symbol34 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurPlaygroundFront extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurPlaygroundStructure_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol35|IZoraHurstonCutouts_Symbol40>;
	readonly sprite: IZoraHurstonCutouts_hurPlaygroundStructure;
}
interface IZoraHurstonCutouts_Symbol35 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_Symbol40 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurPlaygroundStructure extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurPopcorn_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol37>;
	readonly sprite: IZoraHurstonCutouts_hurPopcorn;
}
interface IZoraHurstonCutouts_Symbol37 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurPopcorn extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurStoryAgentchaos_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol38>;
	readonly sprite: IZoraHurstonCutouts_hurStoryAgentchaos;
}
interface IZoraHurstonCutouts_Symbol38 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurStoryAgentchaos extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurStoryBikeman_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol39>;
	readonly sprite: IZoraHurstonCutouts_hurStoryBikeman;
}
interface IZoraHurstonCutouts_Symbol39 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurStoryBikeman extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurStoryCape_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol38>;
	readonly sprite: IZoraHurstonCutouts_hurStoryCape;
}
interface IZoraHurstonCutouts_hurStoryCape extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_blyPlayground4_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol17_>;
	readonly sprite: IZoraHurstonCutouts_blyPlayground4;
}
interface IZoraHurstonCutouts_Symbol17_ extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_blyPlayground4 extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_blyPlaygroundBg_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol46_>;
	readonly sprite: IZoraHurstonCutouts_blyPlaygroundBg;
}
interface IZoraHurstonCutouts_Symbol46_ extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_blyPlaygroundBg extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hur_bAmazed_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol41>;
	readonly sprite: IZoraHurstonCutouts_hur_bAmazed;
}
interface IZoraHurstonCutouts_Symbol41 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hur_bAmazed extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurDinosaurexhibitPterodactyl_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol42>;
	readonly sprite: IZoraHurstonCutouts_hurDinosaurexhibitPterodactyl;
}
interface IZoraHurstonCutouts_Symbol42 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurDinosaurexhibitPterodactyl extends IZoraHurstonCutoutsSprite {
}
interface IZoraHurstonCutouts_hurThoughtBubble_cutout extends IZoraHurstonCutoutsContainer {
	readonly polygons: IZoraHurstonCutoutsArray<IZoraHurstonCutouts_Symbol44>;
	readonly sprite: IZoraHurstonCutouts_hurThoughtBubble;
}
interface IZoraHurstonCutouts_Symbol44 extends IZoraHurstonCutoutsPolygon {
}
interface IZoraHurstonCutouts_hurThoughtBubble extends IZoraHurstonCutoutsSprite {
}
